import { PAGE_LIMIT } from '../../../../constants';
import { API_CALL } from '../../../../middleware/api';
import {
  ADD_SCHEDULE,
  ASSIGN_CAPS_TO_THE_SCHEDULE,
  DELETE_SCHEDULE,
  EDIT_SCHEDULE,
  EDIT_SCHEDULE_REMINDERS,
  GET_CAP_PLOT_DATA,
  GET_CHART_SCHEDULE,
  SCHEDULE_DETAILS,
  SCHEDULE_LIST,
  SCHEDULE_LIST_CLEAR,
} from './constants';

const qs = require('qs');

export const actions = {
  // TODO: Unused
  getSchedules: (patientId, pageRequest) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/v2/patientportal/patient/${patientId}/schedules/`,
      params: { limit: PAGE_LIMIT, ...pageRequest, adherence: true },
    },
    type: SCHEDULE_LIST,
  }),

  // TODO: Unused
  getScheduleDetails: (patientId, scheduleId, pageRequest) => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/v2/patientportal/patient/${patientId}/schedules/${scheduleId}/`,
      params: pageRequest,
    },
    type: SCHEDULE_DETAILS,
  }),

  // TODO: Unused
  deleteSchedule: (patientId, scheduleId) => ({
    [API_CALL]: {
      endpoint: `portal/v2/patientportal/patient/${patientId}/schedules/${scheduleId}/`,
      method: 'DELETE',
    },
    type: DELETE_SCHEDULE,
    id: scheduleId,
  }),

  // TODO: It will blow up!
  // this endpoint should not be used as it is removed from backend
  assignPatientCaps: (data, patientId) => ({
    [API_CALL]: {
      endpoint: `portal/patients/devices/${patientId}/attach`,
      method: 'PUT',
      data,
    },
    type: ASSIGN_CAPS_TO_THE_SCHEDULE,
  }),

  // TODO: Unused
  addSchedule: (patientId, data) => ({
    [API_CALL]: {
      method: 'POST',
      endpoint: `portal/v2/patientportal/patient/${patientId}/schedules/`,
      data,
    },
    type: ADD_SCHEDULE,
  }),

  // TODO: Unused
  editSchedule: (patientId, scheduleId, data) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `portal/v2/patientportal/patient/${patientId}/schedules/${scheduleId}/`,
      data,
    },
    type: EDIT_SCHEDULE,
  }),

  editScheduleReminders: (patientId, scheduleId, data) => ({
    [API_CALL]: {
      method: 'PATCH',
      endpoint: `portal/v2/patientportal/patient/${patientId}/schedules/${scheduleId}/sms`,
      data,
    },
    type: EDIT_SCHEDULE_REMINDERS,
  }),

  getChartSchedule: (patientId, scheduleRootId) => ({
    [API_CALL]: {
      endpoint: `/portal/v2/patientportal/patient/${patientId}/schedules/${scheduleRootId}/chart/schedule`,
      method: 'get',
    },
    type: GET_CHART_SCHEDULE,
  }),

  getCapPlotData: (patientId, scheduleRootId, request) => ({
    [API_CALL]: {
      endpoint: `/portal/v2/patientportal/patient/${patientId}/schedules/${scheduleRootId}/chart/plot`,
      method: 'get',
      params: { ...request },
    },
    type: GET_CAP_PLOT_DATA,
  }),

  getSelfChartSchedule: (scheduleRootId) => ({
    [API_CALL]: {
      endpoint: `/portal/v2/patientportal/adherence/chart/${scheduleRootId}/schedule`,
      method: 'get',
    },
    type: GET_CHART_SCHEDULE,
  }),

  getSelfCapPlotData: (scheduleRootId, request) => ({
    [API_CALL]: {
      endpoint: `/portal/v2/patientportal/adherence/chart/${scheduleRootId}/plot`,
      method: 'get',
      params: { ...request },
    },
    type: GET_CAP_PLOT_DATA,
  }),

  // TODO: Unused
  clearCapsDetails: () => ({
    type: SCHEDULE_LIST_CLEAR,
  }),
};
